// Set by `npm run bump-version`. Do not edit by hand.
export const APP_VERSION = '26.10.3.82';
